import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatPreview } from '@/composables/format-edit/useFormatPreview'
import { splitJobHistories } from '@/utils/format-edit/englishResumePreview'
import EnglishResumePreviewDoc from '@/components/format-edit/english-resume/EnglishResumePreviewDoc.vue'
import EnglishResumePreviewDocPage2 from '@/components/format-edit/english-resume/EnglishResumePreviewDocPage2.vue'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumePreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const { formLib } = useHostServices()
const { cardChanged, scaleStyle, highlightMessage, goCardTo } =
  useFormatPreview(props)

const jobPages = computed(() =>
  splitJobHistories(props.formatData?.jobHistories)
)
const isTwoPage = computed(() => jobPages.value.isTwoPage)
const jobsPage1 = computed(() => jobPages.value.jobsPage1)
const jobsPage2 = computed(() => jobPages.value.jobsPage2)

const fullName = computed(() => {
  const first = props.basicData?.firstName || ''
  const last = props.basicData?.lastName || ''
  return `${first} ${last}`.trim()
})

const fullAddress = computed(() => props.formatData?.address || '')

const fullPhone = computed(() => {
  const t1 = props.basicData?.tel1 || ''
  const t2 = props.basicData?.tel2 || ''
  const t3 = props.basicData?.tel3 || ''
  if (!t1 && !t2 && !t3) return ''
  return [t1, t2, t3].filter(Boolean).join('-')
})

const formatedCreateDate = computed(() => {
  if (!props.formatData?.createDate) return ''
  return formLib.dateFormat(props.formatData.createDate, 'm/yyyy')
})

function checkValid() {}

expose({ checkValid })

return { __sfc: true,props, formLib, cardChanged, scaleStyle, highlightMessage, goCardTo, jobPages, isTwoPage, jobsPage1, jobsPage2, fullName, fullAddress, fullPhone, formatedCreateDate, checkValid, EnglishResumePreviewDoc, EnglishResumePreviewDocPage2 }
}

})